import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  MenuItem,
  Select,
} from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { FormControl } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import {
  DASHBOARD_REST_RESERV_VIEW,
  DASHBOARD_REST_TABLES_VIEW,
  DASHBOARD_REST_VIEW,
  RESTAURANT,
  TABLE_RESERVATION,
  RESTAURANT_COUNTBOX_LIST,
  SREST_FILTER,
  REST_STATUS,
  DATE_FORMAT_ISO,
} from '../../../../constants/DashboardConst';
import CustomCountBox from '../../../../shared/custom-count-box/Custom-Count-Box';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../shared/search-bar/Search-Bar';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import {
  formatDate,
  getOrderCountsList,
  getRestaurantTiming,
} from '../../../../utils/dashboardUtils';
import {
  allRestaurantSelector,
  dashboardSelectedRestaurantSelector,
  selectedHotelSelector,
  setDashboardSelectedRestaurant,
} from '../../../property/propertySlice';
import { fetchRestaurantDashboardReservationDetails, setTimings } from '../../DashboardSlice';
import './DashboardRestaurantList.scss';
import { decryptLocalStorage } from '../../../../utils/authUtils';

const DashboardRestaurantList = (props) => {
  const history = useHistory();
  const {
    onViewToggle,
    allDashboardRestList,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    currentFilterFromLocation,
  } = props;
  const [filterDataList, setFilterDataList] = useState(SREST_FILTER);
  const [dashBoardRestaurantList, setDashBoardBoardRestaurantList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [orderCountList, setOrderCountList] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const originalRestList = useSelector(allRestaurantSelector);
  const selectedHotel = useSelector(selectedHotelSelector);
  const [selectedRestaurant, setRestaurant] = useState(
    useSelector(dashboardSelectedRestaurantSelector),
  );
  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };
  const dispatch = useDispatch();
  const [tempSearchText, setTempSearchText] = useState('');

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onViewDetails = (order) => {
    onViewToggle(DASHBOARD_REST_VIEW, true, order);
  };

  useEffect(() => {
    const ordersBySelectedRestaurant = getOrdersByRestaurant();
    setOrderCountList(getOrderCountsList(RESTAURANT_COUNTBOX_LIST, ordersBySelectedRestaurant));
    setDashBoardBoardRestaurantList(ordersBySelectedRestaurant);
    setFilteredBaseList(ordersBySelectedRestaurant);
    setLoading(false);
    setTempSearchText('');
  }, [allDashboardRestList, selectedRestaurant]);

  useEffect(() => {
    setSearchText('');
    if (currentFilterFromLocation) {
      let subFilter = [...REST_STATUS];
      if (currentFilterFromLocation === 'ALL') {
        subFilter = REST_STATUS.map((x) => {
          return { ...x, selected: false };
        });
      } else {
        subFilter = REST_STATUS.map((x) => {
          return { ...x, selected: x.status === currentFilterFromLocation };
        });
      }
      SREST_FILTER[1].subMenu = subFilter;
      setFilterDataList(SREST_FILTER);
      const filteredItems = allDashboardRestList.filter((item) => {
        return item?.status === currentFilterFromLocation;
      });
      onsetPage(0);
      setDashBoardBoardRestaurantList(
        currentFilterFromLocation !== 'ALL' ? filteredItems : allDashboardRestList,
      );
    }
  }, [currentFilterFromLocation, allDashboardRestList]);

  const setSearchText = (searchText) => {
    setTempSearchText(searchText);
    onsetPage(0);
    if (!searchText) {
      setDashBoardBoardRestaurantList(filteredBaseList);
      return;
    }
    const filteredRows = filteredBaseList?.filter((item) => {
      const guestName = `${item?.firstName} ${item?.lastName}`;
      return (
        guestName?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        item?.id?.toLowerCase()?.includes(searchText?.toLowerCase())
      );
    });
    setDashBoardBoardRestaurantList(filteredRows);
  };

  const getOrdersByRestaurant = () => {
    const currentDate = moment().format(DATE_FORMAT_ISO);

    const ordersBySelectedRestaurant = allDashboardRestList?.filter(
      (obj) => obj?.restaurantId === selectedRestaurant?.id,
    );
    const todayArrivals = ordersBySelectedRestaurant?.filter((order) => {
      return moment(order?.bookingDate).format(DATE_FORMAT_ISO) === currentDate;
    });

    setOrderCountList((prevCountList) => {
      const newCountList = [...prevCountList];
      const todayArrivalsCount = todayArrivals?.length;
      const todayArrivalsIndex = newCountList?.findIndex(
        (item) => item.name === RESTAURANT_COUNTBOX_LIST?.[2]?.name, //Today's Arrivals
      );
      if (todayArrivalsIndex !== -1) {
        newCountList[todayArrivalsIndex].count = todayArrivalsCount?.toString();
      }
      return newCountList;
    });
    return ordersBySelectedRestaurant;
  };

  const resetFilter = () => {
    const resetResFilter = SREST_FILTER?.map((resfilter) => {
      const subMenu = resfilter?.subMenu?.map((resSubMenu) => {
        return { ...resSubMenu, selected: false };
      });
      return { ...resfilter, subMenu };
    });
    setFilterDataList(resetResFilter);
  };

  useEffect(() => {
    resetFilter();
  }, []);

  useEffect(() => {
    if (originalRestList.length && props.restaurantId) {
      let restaurantData = originalRestList[0];
      const newSelected = originalRestList.find(
        (restaurant) => restaurant.id === props.restaurantId,
      );
      if (newSelected) {
        restaurantData = newSelected;
      }
      setRestaurant(restaurantData);
      dispatch(setDashboardSelectedRestaurant(restaurantData));
      dispatch(fetchRestaurantDashboardReservationDetails(restaurantData?.id, selectedHotel));
      const restaurantTiming = getRestaurantTiming(new Date(), restaurantData);
      dispatch(setTimings(restaurantTiming));
    }
  }, [originalRestList.length, props.restaurantId]);

  const filteredRecords = (filters, field) => {
    const ordersBySelectedRes = getOrdersByRestaurant();
    if (field === 'all') {
      setFilteredBaseList(ordersBySelectedRes);
      setDashBoardBoardRestaurantList(ordersBySelectedRes);
      resetFilter();
    } else {
      const filterIdWithFields = filterDataList
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);
      const filteredRecords = ordersBySelectedRes.filter((item) => {
        const doesFilterSatisfy = filterIdWithFields?.map((filter) => {
          const itemValue = item[filter?.field];
          if (filter?.field === 'guestType') {
            return filter?.id.some((id) => id?.toLowerCase() === itemValue?.toLowerCase());
          }
          return filter?.id?.includes(itemValue);
        });
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setFilteredBaseList(filteredRecords);
      setDashBoardBoardRestaurantList(filteredRecords);
    }
  };

  const handleResChange = (e) => {
    if (originalRestList.length > 0) {
      const newSelected = originalRestList.find((restaurant) => restaurant.id === e.target.value);
      setRestaurant(newSelected);
      dispatch(setDashboardSelectedRestaurant(newSelected));
      dispatch(fetchRestaurantDashboardReservationDetails(newSelected.id, selectedHotel));
      const restaurantTiming = getRestaurantTiming(new Date(), newSelected);
      return dispatch(setTimings(restaurantTiming));
    }
  };

  const isCurrentSelectedTile = (status) => {
    if (status === 'ALL') {
      return filterDataList[1]?.subMenu?.every((v) => v.selected === false);
    } else {
      return filterDataList[1]?.subMenu?.find((x) => x.status === status && x.selected);
    }
  };

  return (
    <div className='container px-2 py-2 mw-100'>
      <div className='dashboard-restaurant-list'>
        <div className='pb-2 d-flex gap-2 flex-wrap'>
          {originalRestList?.length > 0 && (
            <div className='col d-flex justify-content-start'>
              <Button
                className='py-2 dropdown-button'
                variant='outlined'
                color='secondary'
                size='medium'
              >
                <FormControl variant='standard' sx={{ mx: 1, minWidth: 240 }}>
                  <Select
                    labelId='restlist-label'
                    id='rest-select-standard'
                    value={selectedRestaurant?.id || decryptLocalStorage('restaurantId')}
                    onChange={(e) => handleResChange(e)}
                    label='Select Restaurant'
                    className='dashboard-restaurant-list-dropdown'
                  >
                    {originalRestList?.map((spaItem) => (
                      <MenuItem key={spaItem.id} value={spaItem.id}>
                        {spaItem.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Button>
            </div>
          )}
          <div className='col d-flex gap-2 justify-content-end flex-wrap'>
            <Button
              variant='outlined'
              color='secondary'
              size='medium'
              endIcon={<ArrowRightIcon />}
              onClick={() => history.push('/restaurant')}
            >
              {'Restaurant Details'}
            </Button>
            <Button
              variant='outlined'
              color='secondary'
              size='medium'
              endIcon={<ArrowRightIcon />}
              onClick={() => onViewToggle(DASHBOARD_REST_TABLES_VIEW, true, null)}
            >
              Tables
            </Button>
            <Button
              variant='outlined'
              color='secondary'
              size='medium'
              endIcon={<ArrowRightIcon />}
              onClick={() => onViewToggle(DASHBOARD_REST_RESERV_VIEW, true, null)}
            >
              Reservations
            </Button>
          </div>
        </div>
        {orderCountList?.length > 0 && (
          <div>
            <div className='py-2 d-flex flex-wrap gap-3'>
              {orderCountList?.map((currentCount, countNdx) => (
                <CustomCountBox count={currentCount} key={countNdx} className={'col'} />
              ))}
            </div>
          </div>
        )}
        <div className='card shadow'>
          <div className='py-2 group-list-container'>
            <SearchBar
              displayAddOrEdit='hide'
              setSearchText={setSearchText}
              filterList={filterDataList}
              setFilterDataList={setFilterDataList}
              filteredRecoard={filteredRecords}
              searchText={tempSearchText}
              setSearch={setTempSearchText}
              actionMenuItems={[]}
            />
            <div className='row py-2 px-3 d-flex'>
              {loading ? (
                <div className='pt-2 col-md-12'>
                  <LinearProgressBar />
                </div>
              ) : (
                dashBoardRestaurantList && (
                  <TableContainer>
                    <Table className='list-table' aria-label='simple table'>
                      <TableHead>
                        <TableRow className='border-white pointer'>
                          <TableCell className='w-15'>Booking Date & Time</TableCell>
                          <TableCell className='w-15' align='center'>
                            Guest name
                          </TableCell>
                          <TableCell className='w-15' align='center'>
                            Guest type
                          </TableCell>
                          <TableCell className='w-20' align='center'>
                            Reservation Date & Time
                          </TableCell>
                          <TableCell className='w-10' align='center'>
                            No of Guests
                          </TableCell>
                          <TableCell className='w-15' align='center'>
                            Status
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? dashBoardRestaurantList.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage,
                            )
                          : dashBoardRestaurantList
                        ).map((item, i) => (
                          <TableRow
                            key={i}
                            className='border-white pointer'
                            onClick={(e) => {
                              onViewDetails(item, e);
                            }}
                          >
                            <TableCell align='left'>
                              {formatDate(item?.bookingDate, 'DD MMM, hh:mm a')}
                            </TableCell>
                            <TableCell align='center'>
                              {item.firstName} {item.lastName}
                            </TableCell>
                            <TableCell align='center'>
                              {item?.guestType?.toLowerCase() === 'resident'
                                ? `Resident `
                                : 'Non Resident'}
                            </TableCell>
                            <TableCell align='center'>
                              {formatDate(item?.date + ' ' + item?.reserveFrom, 'DD MMM, hh:mm a')}
                            </TableCell>
                            <TableCell align='center'>{item.noOfGuests}</TableCell>
                            <TableCell align='center'>
                              <div className='d-flex align-content-center px-2'>
                                <div
                                  className={
                                    item.statusClass +
                                    ' pill d-flex justify-content-center align-items-center py-2 w-90'
                                  }
                                >
                                  <span className='ms-1'>{item.orderStatus ?? 'NA'}</span>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow className='paginator'>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                            count={dashBoardRestaurantList.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: { 'aria-label': 'rows per page' },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardRestaurantList;
